import React from 'react';
import { useReveal } from '../lib/useReveal';
import { trackCustom } from '../lib/pixel';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/hANGvAvMHrKFf7n3KLZ5FJ/ChatGPT_Image_24_jul_2026,_10_09_14_(1).png';
const PREMIUM_TOOLS = [{
  title: 'Vademécum Interactivo',
  description: 'Una consulta rápida para organizar síntomas, conflictos y preguntas posibles.'
}, {
  title: 'Kit Consultor Profesional',
  description: 'Plantillas y estructuras para ordenar una práctica más clara y profesional.'
}, {
  title: 'Cuaderno de Sanación Transgeneracional',
  description: 'Ejercicios guiados para trabajar historia familiar, patrones y memorias emocionales.'
}];
export function PremiumSection() {
  const [ref, visible] = useReveal();
  return <section className="border-t border-[#2E4F48]/15 bg-[#1C3B36] px-4 py-12 sm:px-6 md:py-20" data-id="element-233" data-mp="n3wzasmu30cj">
      <div ref={ref} className={`reveal container mx-auto max-w-6xl ${visible ? 'is-visible' : ''}`} data-id="element-234" data-mp="i5bzgubhuiom">
        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16" data-id="element-235" data-mp="1blf915p81w8i">
          <div data-id="element-236" data-mp="1fobwb9ppigis">
            <p className="text-xs font-bold tracking-[0.22em] text-[#C2683D]" data-id="element-237" data-mp="1fov3pwhqdmik">FORMACIÓN PREMIUM</p>
            <h2 className="mt-4 max-w-2xl font-serif text-4xl font-bold leading-[1.05] text-white md:text-6xl" data-id="element-238" data-mp="11plzzwapokvh">
              Llevá tu formación al siguiente nivel
            </h2>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#E8E0D3] md:text-lg" data-id="element-239" data-mp="1ucpwfcvqnqvn">
              Sumá herramientas pensadas para consultar, acompañar procesos y
              profesionalizar tu forma de aplicar la Biodecodificación.
            </p>

            <div className="mt-8 grid gap-3 sm:grid-cols-3" data-id="element-240" data-mp="1klc1lieqff8u">
              {PREMIUM_TOOLS.map(tool => <article key={tool.title} className="rounded-xl border border-white/15 bg-white/10 p-4" data-id="element-241" data-mp="2dbu68nv3tood">
                  <span className="text-[#C2683D]" data-id="element-242" data-mp="2i2ai43ja128m">✦</span>
                  <h3 className="mt-2 font-serif text-lg font-bold leading-tight text-white" data-id="element-243" data-mp="2i3vbhptuuf4w">{tool.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#E8E0D3]" data-id="element-244" data-mp="2rwgczxwtjumc">{tool.description}</p>
                </article>)}
            </div>

            <a href="#premium" onClick={() => trackCustom('ViewPricingIntent', {
            source: 'premium-section'
          })} className="mt-8 inline-flex items-center justify-center rounded-xl bg-[#C2683D] px-8 py-4 text-sm font-bold tracking-[0.12em] text-white shadow-[0_12px_28px_rgba(194,104,61,0.3)] transition-all hover:-translate-y-1 hover:bg-[#A8542F]" data-id="element-245" data-mp="2hzbq1vv5fv4h">
              QUIERO EL PREMIUM
            </a>
          </div>

          <div className="relative mx-auto w-full max-w-lg" data-id="element-246" data-mp="1uase96cw507n">
            <div className="absolute inset-5 rounded-[2rem] border border-[#C2683D]/40 bg-[#C2683D]/10 rotate-3" data-id="element-247" data-mp="1uclqd169wcn1" />
            <div className="relative rounded-[2rem] border border-white/15 bg-[#E8E0D3] p-4 shadow-2xl sm:p-6" data-id="element-248" data-mp="1qb9zksbnxld9">
              <img src={PRODUCT_IMG} alt="Mockup de la Formación Premium de Biodecodificación" className="w-full object-contain" data-id="element-249" data-mp="s1y8n55r1a2" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}